import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import Tooltip from '../../components/Tooltip';
import { currencyFormatter } from '../../utils/formatters';
import * as S from './SummaryWrapper.css';
const SummaryWrapper = ({ data, style, commonLabel }) => (_jsxs(S.SummaryContainer, Object.assign({ style: style }, { children: [commonLabel && _jsx(S.SummaryLabel, { children: commonLabel }), data === null || data === void 0 ? void 0 : data.map(({ label, amount, suffix, multipleLabel, isMultiple, align, breakWord, percentage, }, index) => {
            const value = (() => {
                if (amount != null) {
                    return currencyFormatter(amount, suffix);
                }
                else if (percentage) {
                    return `${percentage !== null && percentage !== void 0 ? percentage : ''} ${suffix !== null && suffix !== void 0 ? suffix : ''}`;
                }
                return '';
            })();
            return (_jsx(Fragment, { children: isMultiple ? (_jsx(S.SummaryLabel, { children: multipleLabel })) : (_jsxs(_Fragment, { children: [label && _jsx(S.SummaryLabel, { children: label }), _jsx(Tooltip, Object.assign({ title: value || '' }, { children: _jsx(S.SummaryAmount, Object.assign({ align: align, breakWord: breakWord }, { children: value })) }))] })) }, index));
        })] })));
export default SummaryWrapper;
